import update from 'react-addons-update'

import {
  QA_TASKS_SUCCESS
} from '../actions/qa-tasks'

export default function (state = {}, action) {
  switch (action.type) {
    case QA_TASKS_SUCCESS:
      return update(state, {
        [action.payload.qaServicingId]: {
          qaTasks: { $set: action.payload.result }
        }
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/qa-servicings.js